import { render } from "./ConfirmDelete.vue?vue&type=template&id=4bd00540&ts=true"
import script from "./ConfirmDelete.vue?vue&type=script&lang=ts"
export * from "./ConfirmDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__